import { Injectable, inject } from '@angular/core';
import { GanttDimensionDataSourceService } from '@wilson/shift-timeline/assignments-gantt-chart';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { ShiftAssignmentModalState } from '@wilson/shift-timeline/state';
import { TimelineTimeframe } from '@wilson/interfaces';

@Injectable()
export class TimelineModalDimensionDataSourceService extends GanttDimensionDataSourceService {
  private store = inject(Store);

  override frameLengthStream(): Observable<number> {
    return this.store.select(ShiftAssignmentModalState.frameLength);
  }

  override timeframeStream(): Observable<TimelineTimeframe> {
    return this.store.select(ShiftAssignmentModalState.timeframe);
  }

  override visibleDaysRangeStream(): Observable<TimelineTimeframe> {
    return this.store.select(ShiftAssignmentModalState.timeframe);
  }
}
